// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartConfigurationFactories.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

import Factories from './Izenda.Factories';

const configFactories = new Factories('Report Part Configuration', true);

export default {
  /**
   * Set configuration of a report part type
   * @param {string} reportPartType Report part type
   * @param {Object} configuration Report part configuration
   */
  setConfiguration(reportPartType, configuration) {
    ensure(reportPartType, 'ReportPartType must have a value');
    ensure(configuration, 'Configuration must have a value');
    ensure(configuration.model, 'Configuration must defined a model class of report part type');

    configFactories.containKey(reportPartType) && configFactories.unregister(reportPartType);
    configFactories.register(reportPartType, () => configuration);
  },

  /**
   * Get configuration of a report part type
   * @param {string} reportPartType Report part type
   */
  getConfiguration(reportPartType) {
    return configFactories.create(reportPartType);
  },

  /**
   * Reset the factories data
   */
  reset() {
    configFactories.reset();
  }
};



// WEBPACK FOOTER //
// ./ui/share/factories/Izenda.ReportPartConfigurationFactories.js